/**
 * CAMPANHA DIA DAS MÃES — Motor de pétalas (v5 — Simples e Robusto)
 *
 * Coordenadas absolutas de documento (sem window.scrollY no spawn).
 * O navegador rola a página nativamente; as pétalas ficam "presas" no documento.
 * Sem 3D distortion, sem virtualFloor, sem teletransporte.
 */
(function () {
  'use strict';

  /* ── CSS ── */
  var styleEl = document.createElement('style');
  styleEl.textContent =
    '#maes-physics-petals{' +
      'position:absolute;top:0;left:0;' +
      'width:100%;height:100%;' +
      'pointer-events:none;overflow:visible;' +
      'z-index:5;' +
    '}' +
    '.sakura-petal{' +
      'position:absolute;' +
      'width:12px;height:16px;' +
      'background:#D4AF37;' +
      'border-radius:2px 10px 2px 10px;' +
      'opacity:0.8;' +
      'pointer-events:none;' +
      'will-change:transform;' +
      'transition:opacity 0.9s ease;' +
    '}';
  document.head.appendChild(styleEl);

  /* ── Container ── */
  var container = document.getElementById('maes-physics-petals');
  if (!container) {
    container = document.createElement('div');
    container.id = 'maes-physics-petals';
    container.setAttribute('aria-hidden', 'true');
    document.body.appendChild(container);
  }

  /* ── Configurações ── */
  var PETAL_COUNT = 22;

  /* Banda de spawn (px absolutos no documento) — onde o galho vive */
  var SPAWN_Y_MIN  = 200;
  var SPAWN_Y_SPAN = 300;   /* 200–500 px do topo do documento */

  /* Uma pétala "morre" quando ultrapassa viewport + folga generosa */
  var DEATH_EXTRA  = 1000;

  function rand(a, b) { return a + Math.random() * (b - a); }

  /* ── Reset de pétala (spawn / respawn) ── */
  function resetPetal(p, spreadY) {
    p.x          = rand(0, window.innerWidth * 0.45);
    p.y          = SPAWN_Y_MIN + Math.random() * (spreadY || SPAWN_Y_SPAN);
    p.vy         = rand(0.5, 1.1);
    p.angle      = rand(0, Math.PI * 2);
    p.angleSpeed = rand(0.012, 0.028);
    p.rot        = rand(0, 360);
    p.rotSpeed   = rand(-1.8, 1.8);
    p.dying      = false;
    p.el.style.opacity = rand(0.55, 0.90).toFixed(2);
  }

  /* ── Criação do pool fixo ── */
  var petals = [];

  for (var i = 0; i < PETAL_COUNT; i++) {
    var el = document.createElement('div');
    el.className = 'sakura-petal';
    container.appendChild(el);

    var p = { el: el, x: 0, y: 0, vy: 0, angle: 0, angleSpeed: 0,
              rot: 0, rotSpeed: 0, dying: false };

    /* Cold-start: distribuídas por uma faixa maior para cena já "viva" */
    resetPetal(p, window.innerHeight * 0.70);
    petals.push(p);
  }

  /* ── Loop principal ── */
  function tick() {
    var deathLine = window.innerHeight + DEATH_EXTRA;

    for (var i = 0; i < petals.length; i++) {
      var p = petals[i];

      if (p.dying) continue;

      /* Física: queda + oscilação lateral */
      p.angle += p.angleSpeed;
      p.y     += p.vy;
      p.x     += Math.sin(p.angle) * 1.5;
      p.rot   += p.rotSpeed;

      /* Wrap horizontal */
      if (p.x < -20)                    p.x = window.innerWidth + 20;
      if (p.x > window.innerWidth + 20) p.x = -20;

      /* Morte: pétala caiu além da linha de morte */
      if (p.y > deathLine) {
        p.dying = true;
        p.el.style.opacity = '0';

        /* Aguarda o fade-out CSS e reseta no galho */
        (function (petal) {
          setTimeout(function () {
            resetPetal(petal);
          }, 950);   /* ligeiramente menor que a transition (0.9s) */
        })(p);
        continue;
      }

      /* Atualiza posição — apenas translate + rotateZ, sem distorção 3D */
      p.el.style.transform =
        'translate3d(' + p.x.toFixed(1) + 'px,' + p.y.toFixed(1) + 'px,0)' +
        ' rotateZ(' + p.rot.toFixed(1) + 'deg)';
    }

    requestAnimationFrame(tick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { requestAnimationFrame(tick); });
  } else {
    requestAnimationFrame(tick);
  }

}());
